var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepsCss"},_vm._l((_vm.stepsContent),function(step){return _c('div',{key:step.title,staticClass:"stepsCss-main",class:[{ active: step.active }, { rspdisabled: step.disabled }]},[_c('div',{staticClass:"stepsCss-text"},[_c('p',[_vm._v(" "+_vm._s(step.title)+" ")])]),_c('div',{staticClass:"stepsCss-border"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }